import * as dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import { monitor_table_ajax } from '@/utils/monitor/monitor.js'

// case 給的時間是 UTC
dayjs.extend(LocalizedFormat)

const timestamp_to_input_format = (format) => {
    return (timestamp_str) => timestamp_str ? dayjs(+timestamp_str).format(format) : dayjs().format(format)
}

export const timestamp_to_date = timestamp_to_input_format('YYYY-MM-DD')
export const timestamp_to_time = timestamp_to_input_format('HH:mm')

export const compute_case_limit_time = (timestamp_str, date_selected) => {
    const is_need_limit_time = (timestamp_str, date_selected) => {
        return timestamp_to_date(timestamp_str) === date_selected
    }

    return is_need_limit_time(timestamp_str, date_selected) ? timestamp_to_time(timestamp_str) : ""
}

export function call_case_monitor_table_ajax(table_value) {
    const case_selected = this.$store.state.case.case_selected
    let date_time = new Date(Number(case_selected.end))
    date_time.setHours(date_time.getHours() + 8)
    const new_date = date_time.toISOString().substring(0, 10)
    const new_time = date_time.toISOString().substring(11, 16)
    const formated_date_time = `${new_date} ${new_time}:00`
    setTimeout(() => {
        this.date = new_date
        this.time = new_time
    }, 0)
    monitor_table_ajax.call(this, table_value, formated_date_time);
}